import { Link } from "react-router-dom";
import { AlertTriangle, Clock } from "lucide-react";

export const BillingBanner = ({ company, role }) => {
  if (!company) return null;
  const isOwner = role === "owner";
  const locked = company.billing_locked_reason;

  if (locked) {
    return (
      <div
        className="mx-4 mt-4 lg:mx-8 border border-[#E13C32]/60 bg-[#E13C32]/10 rounded-sm px-4 py-3 flex items-center gap-3 flex-wrap"
        data-testid="billing-locked-banner"
      >
        <AlertTriangle className="w-4 h-4 text-[#E13C32] flex-shrink-0" />
        <span className="text-sm text-white flex-1 min-w-[200px]">
          {isOwner ? locked : "The arena is locked — ask your company owner to update billing."}
        </span>
        {isOwner && (
          <Link
            to="/dashboard/billing"
            className="text-xs font-label px-3 py-1.5 bg-[#E13C32] text-white rounded-sm hover:bg-[#EB5A50] transition-colors"
            data-testid="billing-locked-cta"
          >
            FIX IN BILLING →
          </Link>
        )}
      </div>
    );
  }

  if (company.plan === "trial" && company.trial_ends_at && isOwner) {
    const daysLeft = Math.max(0, Math.ceil((new Date(company.trial_ends_at) - Date.now()) / 86400000));
    return (
      <div
        className="mx-4 mt-4 lg:mx-8 border border-[#FFC832]/40 bg-[#FFC832]/[0.06] rounded-sm px-4 py-2.5 flex items-center gap-3 flex-wrap"
        data-testid="trial-countdown-banner"
      >
        <Clock className="w-4 h-4 text-[#FFC832] flex-shrink-0" />
        <span className="text-sm text-[#FFC832] flex-1 min-w-[200px]">
          Free trial — <b>{daysLeft} day{daysLeft === 1 ? "" : "s"} left</b>.
        </span>
        <Link
          to="/dashboard/billing"
          className="text-xs font-label px-3 py-1.5 border border-[#FFC832]/50 text-[#FFC832] rounded-sm hover:bg-[#FFC832]/10 transition-colors"
          data-testid="trial-banner-cta"
        >
          VIEW PLANS →
        </Link>
      </div>
    );
  }

  return null;
};

export default BillingBanner;
